import useAxios from 'axios-hooks';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DebinAnimation } from './DebinAnimation';
import { UrlsBack, UrlsFront } from '../../constants/urls';
import { IFixedTermNew } from '../../types/IFixedTermNew';
import { VStack, Button, HStack } from '@bpba/ui-components';
import { DebinSuccess } from './DebinSuccess';
import { DebinRejected } from './DebinRejected';
import { PanelDivisor } from '../shared/PanelDivisor';
import { SubTitulo } from '../shared/SubTitulo';
import { Titulo } from '../shared/Titulo';
import { axiosMessageExtractor, BackendErrorContainer } from '../../config/axiosMessageExtractor';
import { useErrorMessage } from '../shared/useErrorMessage';
import { IFixedTermNewResponse } from '../../types/IFixedTermNewResponse';
import { MENU_ITEM_NEW } from '../../constants/data';
import { DebinResult, IDebin } from '../../types/IDebin';
import { AxiosError, AxiosResponse } from 'axios';
import { useGetDebin } from '../shared/useGetDebin';

export const DebinConfirm: FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage, showError, clearError] = useErrorMessage(axiosMessageExtractor);
  const [, step1] = useAxios<IFixedTermNewResponse, IFixedTermNew>(
    {
      url: UrlsBack.FixedTermConfirm,
      method: 'POST',
    },
    { manual: true }
  );

  const [step2] = useGetDebin();
  const [loading, setLoading] = useState<boolean>(true);
  const validResponse = !loading && !showError;
  const invalidResponse = !loading && showError;

  const redirectToStart = () => {
    navigate(UrlsFront.FixedTerms);
  };

  const onError = (err: AxiosError<BackendErrorContainer, any> | undefined) => {
    setErrorMessage(err);
    setLoading(false);
  };

  const processResponse2 = ({ data }: AxiosResponse<IDebin, any, {}>) => {
    if (data?.result == null || data.result === DebinResult.ERROR) {
      setErrorMessage();
    }
    setLoading(false);
  };

  useEffect(() => {
    clearError();

    step1({
      data: { id: state?.debinId },
    })
      .then(() => {
        step2(state?.debinId).then(processResponse2).catch(onError);
      })
      .catch(onError);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step1, state?.debinId]);

  return (
    <VStack>
      <Titulo>{MENU_ITEM_NEW}</Titulo>
      <PanelDivisor flexDirection={'column'}>
        <SubTitulo>Aceptación de DEBIN</SubTitulo>

        {loading && <DebinAnimation />}

        {validResponse && <DebinSuccess show={validResponse} />}

        {invalidResponse && <DebinRejected show={invalidResponse} reason={errorMessage?.message} />}

        {!loading && (
          <HStack justifyContent={'end'}>
            <Button type="button" variant="transparent" onClick={redirectToStart} maxWidth={['100px', '200px']} mx={'0px !important'}>
              Volver
            </Button>
          </HStack>
        )}
      </PanelDivisor>
    </VStack>
  );
};
